import { render, staticRenderFns } from "./rhCommonPhrases.vue?vue&type=template&id=3bd3e014"
import script from "./rhCommonPhrases.vue?vue&type=script&lang=js"
export * from "./rhCommonPhrases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports